exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-photo .weui-cell_access {\n  padding: 8px 0 !important;\n}\n.page-photo .weui-cell__ft {\n  color: #444;\n}\n", ""]);

// exports
